/* -------------------------------------------------------------
   Sticky-header offset → CSS variable
   ------------------------------------------------------------- */
(() =>
{
	const header = document.querySelector('.jsSiteHeader');
	if (!header) return;                     // nothing to do

	let finalTimer = null;
	const FINAL_FIX_MS = 300;                // matches your 300 ms animation

	/* ---- live update (called on every rAF while scrolling) ---- */
	const updateLive = () =>
	{
		const bottom = Math.round(Math.max(0, header.getBoundingClientRect().bottom));
		document.documentElement.style.setProperty(
			'--headerBottomFromViewportTop',
			`${bottom}px`
		);
	};

	/* ---- schedule the “final” correction after inactivity ---- */
	const scheduleFinal = () =>
	{
		clearTimeout(finalTimer);
		finalTimer = setTimeout(updateLive, FINAL_FIX_MS);
	};

	/* ---- scroll handler (throttled live + final) ---- */
	let ticking = false;
	const onScroll = () =>
	{
		// live update – at most once per animation frame
		if (!ticking)
		{
			requestAnimationFrame(() =>
			{
				updateLive();
				ticking = false;
			});
			ticking = true;
		}
		// always push the final fix forward
		scheduleFinal();
	};

	/* ---- resize handler ---- */
	const onResize = () =>
	{
		updateLive();       // instant reaction to width changes
		scheduleFinal();    // in case the header height changed
	};

	/* ---- wire everything up ---- */
	window.addEventListener('scroll', onScroll, { passive: true });
	window.addEventListener('resize', onResize);

	/* ---- react to the header's own size changing, for any reason ----
	   scroll/resize don't fire when e.g. a header image or webfont loads
	   in late and the header grows/shrinks on its own. Until now that left
	   --headerBottomFromViewportTop stale (and the mega menu mispositioned,
	   since it's offset from that variable) until the visitor happened to
	   scroll or resize - on a slow-loading page, that could be a while.
	   ResizeObserver reacts directly to the header's actual box changing,
	   independent of full page load. */
	if (typeof ResizeObserver !== 'undefined')
	{
		const headerResizeObserver = new ResizeObserver(updateLive);
		headerResizeObserver.observe(header);
	}

	/* ---- initial value ---- */
	updateLive();

	/* -------------------------------------------------------------
	   PUBLIC API – other scripts (e.g. urgent-message dismiss)
	   can force an immediate live update:
		  window.updateHeaderOffset?.();
	   ------------------------------------------------------------- */
	window.updateHeaderOffset = () =>
	{
		updateLive();       // instant
		scheduleFinal();    // still guarantee a clean value after 300 ms
	};
})();